import React from 'react';
import classNames from 'classnames';
import pt from 'prop-types';

import Flash from 'components/flash';
import LoadingBar from 'components/loading/bar';

export default class LoginLayout extends React.PureComponent {
  static propTypes = {
    className: pt.string,
    children: pt.node.isRequired,
    flash: pt.object,
  };

  render() {
    const { flash, children, className } = this.props;

    return (
      <div className={classNames('login-container', className)}>
        <LoadingBar />
        <Flash {...flash} />
        <div className="login-wrapper">
          <div className="login-wrapper-left">{children}</div>
          <div className="login-wrapper-right" />
        </div>
      </div>
    );
  }
}
